/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtoform3Inputs */

const en_aiflowtoform3 = /** @type {(inputs: Aiflowtoform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use in the form`)
};

const de_aiflowtoform3 = /** @type {(inputs: Aiflowtoform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ins Formular übernehmen`)
};

/**
* | output |
* | --- |
* | "Use in the form" |
*
* @param {Aiflowtoform3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtoform3 = /** @type {((inputs?: Aiflowtoform3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtoform3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtoform3(inputs)
	return de_aiflowtoform3(inputs)
});
export { aiflowtoform3 as "aiFlowToForm" }